import { type SearchPrometheusParams } from 'queries/prometheus/types'

export const prometheusQueryKeys = {
  searchMonitors: (params: SearchPrometheusParams & { teamId: string }) =>
    ['/prometheus/monitors', params] as const
}
